<div
  class="platform-switcher position-relative w-100"
  ref="switcher"
>
  <button
    class="platform-switcher-toggle d-flex align-items-center text-decoration-none w-100 rounded d-none"
    type="button"
    aria-label="Open Data Warehousing"
    :aria-busy="is_switching ? 'true' : 'false'"
    data-tooltip="Data Warehousing"
    :disabled="!primary_platform || primary_platform.disabled || is_switching"
    @click="switch_to_primary_platform"
  >
    <span
      v-if="is_switching"
      class="spinner-border spinner-border-sm platform-switcher-icon me-2"
      aria-hidden="true"
    ></span>
    <i v-else class="bi bi-window-stack platform-switcher-icon me-2"></i>
    <span class="platform-switcher-text sidebar-menu-text text-white-50 fw-semibold text-xs">
      Data Warehousing
    </span>
  </button>

  <p v-if="error_message" class="platform-switcher-error text-danger small px-2 pt-2 mb-0">
    {{ error_message }}
  </p>
</div>
